import Axios from "../../api/Axios";
const BASE_URL = "BankingTransaction/";
export const EndpointBankingTransaction = {
    SaveBankTransaction: "SaveBankTransaction",
    GetNewDepositChequeList: "GetNewDepositChequeList",
    GetRealizeBouncedChequeList: "GetRealizeBouncedChequeList",
    PopulateBankDetailsData: "PopulateBankDetailsData",
    GetAllChequeRecords: "GetAllChequeRecords",
    ExportAllChequeRecords: "ExportAllChequeRecords"

};

export const createAPIBankingTransaction = () => {
    return {
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };
};